import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, mergeProps as _mergeProps, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-wrap align-center ga-2 my-2" }
const _hoisted_2 = {
  key: 0,
  class: "d-inline-block text-caption dataset-patttern-chip"
}

import { ref, computed } from "vue";
import { supportsTouchscreen } from "@cosmicds/vue-toolkit";
import type { UserDataset } from "../types";
import { useTempoStore } from "../stores/app";
import { moleculeName } from "../esri/utils";


interface DatasetCardProps {
  datasets: UserDataset[];
  turnOnSelection?: boolean;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'DatasetCard',
  props: /*@__PURE__*/_mergeModels({
    datasets: {},
    turnOnSelection: { type: Boolean }
  }, {
    "selectedDatasets": {
  type: Array as () => string[],
  default: () => [],
},
    "selectedDatasetsModifiers": {},
  }),
  emits: ["update:selectedDatasets"],
  setup(__props: any) {

const store = useTempoStore();



// create a selectedDatasets model, to hold selectedDatsets use (defineModel). should just store the dataset.id values
const selectedDatasets = _useModel<string[]>(__props, 'selectedDatasets');

const touchscreen = supportsTouchscreen();


const openGraphs = ref<Record<string,boolean>>({});



const datasetRowRefs = ref({});

function isFolded(dataset: UserDataset): boolean {
  return !!(dataset.timeRange && dataset.timeRange.type === 'folded');
}


const datesetsWithNotFoldedFisrt = computed(() => {
  return [...__props.datasets].sort((a, b) => {
    const aFolded = isFolded(a) ? 1 : 0;
    const bFolded = isFolded(b) ? 1 : 0;
    return aFolded - bFolded;
  });
});


function _removeDataset(dataset: UserDataset) {
  store.deleteDataset(dataset);

  delete openGraphs[dataset.id];
  delete datasetRowRefs[dataset.id];
}



return (_ctx: any,_cache: any) => {
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_hover = _resolveComponent("v-hover")!
  const _component_v_list = _resolveComponent("v-list")!

  return (_openBlock(), _createBlock(_component_v_list, null, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datesetsWithNotFoldedFisrt.value, (dataset) => {
        return (_openBlock(), _createBlock(_component_v_hover, {
          key: dataset.id
        }, {
          default: _withCtx(({ isHovering, props }) => [
            _createVNode(_component_v_list_item, _mergeProps({ ref_for: true }, props, {
              ref_for: true,
              ref: (el) => datasetRowRefs.value[dataset.id] = el,
              class: "selection-item my-2 rounded-lg",
              style: { 'background-color': isFolded(dataset) ? '#333' : '#999', 'color': isFolded(dataset) ? '#fff' : '#000' },
              ripple: _unref(touchscreen),
              lines: "two"
            }), _createSlots({
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_v_chip, {
                    size: "small",
                    variant: "flat",
                    color: dataset.customColor ?? dataset.region.color
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(dataset.name ?? dataset.region.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["color"]),
                  _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_v_chip, {
                      label: "",
                      size: "small",
                      variant: "flat",
                      color: dataset.region.color
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Region: " + _toDisplayString(dataset.region.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["color"]),
                    _createVNode(_component_v_chip, {
                      label: "",
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Mol: " + _toDisplayString(_unref(moleculeName)(dataset.molecule)), 1)
                      ]),
                      _: 2
                    }, 1024),
                    (dataset.timeRange)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                          _createElementVNode("span", null, _toDisplayString(dataset.timeRange.description), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _renderSlot(_ctx.$slots, "action-row", {
                  isHovering: isHovering,
                  dataset: dataset
                })
              ]),
              _: 2
            }, [
              (__props.turnOnSelection)
                ? {
                    name: "prepend",
                    fn: _withCtx(() => [
                      _createVNode(_component_v_checkbox, {
                        modelValue: selectedDatasets.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedDatasets).value = $event)),
                        value: dataset.id,
                        onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
                        "hide-details": "",
                        density: "compact"
                      }, null, 8, ["modelValue", "value"])
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1040, ["style", "ripple"])
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 3
  }))
}
}

})